import { IOrderItem } from 'models/orders'

// По убыванию того, насколько характеристика отличает товар от похожих
const MAIN_CHARACTERISTICS = [
  /^размер/,
  /^(цвет|расцветка)/,
  /^вес/,
  /^объ[её]м/,
  /фасовк|в упаковке/,
  /^матер/
]
const MAIN_LIMIT = 2

const getPriority = (name: string) => {
  const normalized = name.trim().toLowerCase()
  const index = MAIN_CHARACTERISTICS.findIndex((pattern) => pattern.test(normalized))
  return index === -1 ? MAIN_CHARACTERISTICS.length : index
}

// У вариации — значения, которыми она отличается от соседних (как в названии: «Зелёный, Cob»).
// У остальных — две главные характеристики, а если главных нет — первые две
export const getItemCharacteristics = (product: IOrderItem['product_id'] | null | undefined) => {
  const variation = (product?.variation_characteristic ?? [])
    .map(({ value }) => value.trim())
    .join(', ')
  if (variation) {
    return { variation, main: [] }
  }

  const main = (product?.characteristic ?? [])
    .filter(({ name, value }) => name?.trim() && value?.trim())
    .sort((a, b) => getPriority(a.name) - getPriority(b.name))
    .slice(0, MAIN_LIMIT)
  return { variation: null, main }
}
